export const getBurgenlandData = () => ({
  name: "Burgenland",
  country: "Autriche",
  description: "Burgenland est une région viticole d'Autriche, réputée pour ses vins liquoreux exceptionnels et ses vins rouges de qualité. Cette région bénéficie d'un climat continental avec des influences pannoniennes, créant des conditions idéales pour la production de vins liquoreux.",
  type: "region",
  area: "12,000 ha",
  production: "0.7 million hectolitres",
  climate: "Climat continental avec influences pannoniennes, étés chauds et hivers doux",
  soil: "Sols calcaires, argileux, sableux, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences pannoniennes, étés chauds et hivers doux",
    soil: "Sols calcaires, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une acidité vive",
    red: "Vins rouges structurés et fruités, avec des tanins mûrs",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sweet: "Vins liquoreux exceptionnels, notamment les Beerenauslese et Trockenbeerenauslese"
  },
  history: "La viticulture à Burgenland remonte à l'époque romaine. La région est réputée pour ses vins liquoreux exceptionnels, notamment les Beerenauslese et Trockenbeerenauslese. Aujourd'hui, Burgenland est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine autrichienne traditionnelle, desserts, fromages affinés, plats locaux",
  subregions: {
    "Neusiedlersee": {
      name: "Neusiedlersee",
      description: "Région viticole autour du lac, spécialisée dans les vins liquoreux",
      area: "6,000 ha",
      characteristics: "Sols sableux, climat humide, vins liquoreux",
      grapeVarieties: ["welschriesling", "muscat", "zweigelt", "blaufrankisch"]
    },
    "Mittelburgenland": {
      name: "Mittelburgenland",
      description: "Région viticole produisant des vins rouges de qualité",
      area: "3,000 ha",
      characteristics: "Sols calcaires, climat continental, vins rouges",
      grapeVarieties: ["blaufrankisch", "zweigelt", "saint-laurent", "pinot-noir"]
    },
    "Südburgenland": {
      name: "Südburgenland",
      description: "Région viticole méridionale avec des vignobles établis",
      area: "3,000 ha",
      characteristics: "Sols argileux, microclimats, vins équilibrés",
      grapeVarieties: ["blaufrankisch", "zweigelt", "welschriesling", "muscat"]
    }
  },
  grapeVarieties: [
    {
      name: "Blaufränkisch",
      percentage: "35%",
      description: "Cépage rouge principal, produisant des vins structurés et fruités",
      characteristics: "Structuré, fruité, tanins mûrs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Zweigelt",
      percentage: "25%",
      description: "Cépage rouge produisant des vins élégants et fruités",
      characteristics: "Élégant, fruité, tanins fins",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Welschriesling",
      percentage: "20%",
      description: "Cépage blanc produisant des vins secs et liquoreux",
      characteristics: "Sec à liquoreux, aromatique, acidité vive",
      wineStyles: "Sec à liquoreux, aromatique"
    },
    {
      name: "Muscat",
      percentage: "10%",
      description: "Cépage blanc produisant des vins aromatiques et liquoreux",
      characteristics: "Aromatique, liquoreux, notes florales",
      wineStyles: "Sec à liquoreux, aromatique"
    },
    {
      name: "Autres",
      percentage: "10%",
      description: "Autres cépages incluant Saint-Laurent, Pinot Noir et cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Neusiedlersee", x: 16.5, y: 47.8, color: "#4B164C", size: 5 },
    { region: "Mittelburgenland", x: 16.7, y: 47.6, color: "#6d2c7a", size: 4 },
    { region: "Südburgenland", x: 16.3, y: 47.4, color: "#8a4a8a", size: 4 }
  ]
}); 